import { useTranslation } from 'next-i18next';
import styles from './ShippingRestrictionMessage.module.scss';

const ShippingRestrictionMessage = ({
  shippingRestrictions,
}: {
  shippingRestrictions: any;
}) => {
  const { t } = useTranslation('pdp');

  const isPOBox =
    shippingRestrictions?.restriction_level === 'R1' ||
    shippingRestrictions?.restriction_level === 'R6' ||
    shippingRestrictions?.restriction_level === 'R10';

  const onlyInCanada =
    shippingRestrictions?.restriction_level === 'R4' ||
    shippingRestrictions?.restriction_level === 'R5' ||
    shippingRestrictions?.restriction_level === 'R6' ||
    shippingRestrictions?.restriction_level === 'R10';

  const bikeShipping = shippingRestrictions?.restriction_level === 'R10';

  return (
    <div className={styles.shippingRestrictionMessageContainer}>
      <p>{bikeShipping && t('product.shipping.message.bike.shipping')}</p>
      <p>{isPOBox && t('product.shipping.message.po.box')}</p>
      <p>{onlyInCanada && t('product.shipping.message.only.in.canada')}</p>
    </div>
  );
};

export default ShippingRestrictionMessage;
